const parseLinkTokens = {
  COMMLINK: 'community link',
  COMMONWEALTH: 'commonwealth',
  DISTRIBION: 'distribion',
  EASYSITE: 'easysite',
}

export default parseLinkTokens
